"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
require("./index.scss");
const react_select_1 = __importDefault(require("react-select"));
const clsx_1 = __importDefault(require("clsx"));
class SelectComponent extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "menuIsOpen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "onMenuOpen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => (this.menuIsOpen = true)
        });
        Object.defineProperty(this, "onMenuClose", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => (this.menuIsOpen = false)
        });
        Object.defineProperty(this, "onValueChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (newValue) => {
                if (this.props.onValueChange) {
                    this.props.onValueChange(newValue);
                }
            }
        });
        (0, mobx_1.makeObservable)(this, {
            menuIsOpen: mobx_1.observable,
            onMenuOpen: mobx_1.action,
            onMenuClose: mobx_1.action,
            onValueChange: mobx_1.action,
        });
    }
    render() {
        const { isSearchable, options, defaultValue, selectedValue, isDisabled, isMenuPlacementTop, activeInputState, isClearable, placeholder, name, } = this.props;
        const classNames = (0, clsx_1.default)('select-component', this.menuIsOpen && 'focus', activeInputState && 'active-search', isDisabled && 'disabled');
        let components;
        if (isDisabled) {
            components = { DropdownIndicator: () => null, IndicatorSeparator: () => null };
        }
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement(react_select_1.default, { name: name, inputId: name, isSearchable: !!isSearchable, classNamePrefix: "react-select", onMenuOpen: this.onMenuOpen, onMenuClose: this.onMenuClose, onChange: this.onValueChange, options: options, defaultValue: defaultValue, menuIsOpen: this.menuIsOpen, value: selectedValue, isDisabled: isDisabled, isClearable: isClearable, menuPlacement: isMenuPlacementTop ? 'top' : 'auto', placeholder: placeholder, components: components })));
    }
}
exports.default = (0, mobx_react_1.observer)(SelectComponent);
